import React, { useEffect, useState } from "react";
import { ValidationMessage } from "../../components/Utils";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import {
  ROLE_EDIT,
  ROLE_UPDATE,
  PERMISSION_LIST
} from "../../routes/routes";
import Form from 'react-bootstrap/Form';
import { toast } from "react-toastify";
import Loader from '../../components/common/Loader'; // Import the loader component
import { NoDataFound } from "../../components/Utils";
import { FullPageLoader } from '../../components/common/Loader'; // Import the loader component
import { ROLE_UPDATED } from "../../constant/constant";

const RoleEdit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [btnDisabled, setBtnDisabled] = useState(false);
  const [selectAllOption, setSelectAllOption] = useState(false);
  const [loading, setLoading] = useState(true);
  const [permissionLoading, setPermissionLoading] = useState(true);
  const [permissionOptions, setPermissionOptions] = useState({});
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});

  /*
   * @param {*} input
   * @param {*} callback
  */

  const submit = () => {
    setBtnDisabled(true);
    let requestBody = { ...form };
    axios
      .put(ROLE_UPDATE + id, requestBody)
      .then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(ROLE_UPDATED);
          navigate("/roles");
        }
      })
      .catch((err) => {
        if (err?.response?.status === 422) {
          const error = err.response.data.error;
          setErrors(error);
          toast.error(err.response.data.msg);
        } else if (err?.response?.data?.msg) {
          toast.error(err.response.data.msg);
        }
      }).finally(() => {
        setBtnDisabled(false);
      });
  };
  useEffect(() => {
    axios.get(ROLE_EDIT + id).then((res) => {
      if (res.status === 200 && res.data.success) {
        let responseData = res.data.data;
        setForm({
          id: responseData?.id,
          name: responseData?.name,
          permissions: responseData?.permissions || [],
          status: responseData?.status
        });
      }
    }).finally(() => {
      setLoading(false);
    });

    const fetchData = async () => {
      try {
        // Fetch permission data
        const permissionResponse = await axios.get(PERMISSION_LIST)
          .finally(() => {
            setPermissionLoading(false);
          });
        const fetchedPermissionOptions = permissionResponse.data.data;
        setPermissionOptions(fetchedPermissionOptions);
      } catch (error) {
        console.error('Error while fetching permission data:', error);
      }
    }
    fetchData();
  }, [id]);
  return (
    <div className="content-wrapper">
      <FullPageLoader visible={loading || btnDisabled} />
      <div className="container-fluid p-0 mt-0 mb-2">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Roles</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li>
                  <Link to={"/roles"}>
                    <span>Roles List</span>
                  </Link>
                </li>
                <li>
                  <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 24 24" fill="none" stroke="#212b39" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"><path d="M9 18l6-6-6-6" /></svg>
                </li>
                <li><span className="active_breadcrumb">Edit Role</span></li>
              </ol>
            </div>
            <div className="col-lg-6">
              <div className="pt-btn">
                <Link to={"/roles"}>
                  <button type="button" className="btn btn-dark igoback_btn">
                    <i className="bx bx-exit"></i> back
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="row">
          <div className="col-xl-12">
            <div className="card mb-4">
              <div className="card-header d-flex justify-content-between align-items-center">
                {/* <h5 className="mb-0">Edit Role</h5> */}
              </div>
              <div className="card-body">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="name"
                        >
                          Role Name<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          placeholder="Name"
                          onChange={(e) =>
                            setForm({ ...form, name: e.target.value })
                          }
                          onBlur={(e) =>
                            setForm({ ...form, name: e.target.value })
                          }
                          defaultValue={form?.name}
                        />
                        <ValidationMessage error={errors} name="name" />
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="mb-3">
                        <label
                          className="form-label"
                          htmlFor="membership_status"
                        >
                          Permission access<span className="text-danger">*</span>
                        </label>
                        <div className="table-responsive text-nowrap">
                          <table className="table itable table-bordered">
                            <thead>
                              <tr>
                                <th>Menu Name</th>
                                <th>Access name</th>
                                <th className="text-center">Add</th>
                                <th className="text-center">Edit</th>
                                <th className="text-center">View</th>
                                <th className="text-center">Delete</th>
                                <th className="text-center">Export</th>
                              </tr>
                            </thead>
                            <tbody>
                              {permissionLoading ? (
                                <Loader loading={permissionLoading} colspan="7" />
                              ) :
                                Object.keys(permissionOptions).length > 0 ? (
                                  Object.keys(permissionOptions).map((menu, i) => {
                                    // Group permissions by base name (feature)
                                    const features = {};
                                    ['create', 'edit', 'list', 'delete', 'export'].forEach(type => {
                                      const perms = permissionOptions[menu][type];
                                      if (perms && Array.isArray(perms)) {
                                        perms.forEach(p => {
                                          const baseName = p.access_name || p.name.split('-')[0];
                                          if (!features[baseName]) features[baseName] = {};
                                          features[baseName][type] = p;
                                        });
                                      }
                                    });

                                    const featureKeys = Object.keys(features);
                                    return featureKeys.map((featureName, index) => {
                                      const featurePerms = features[featureName];

                                      const toggleSingle = (name, checked, isNonViewAction) => {
                                        if (name === 'dashboard-view' && !checked) return;

                                        let updatedPermissions = [...(form.permissions || [])];
                                        if (checked) {
                                          updatedPermissions.push(name);
                                          // Auto-select view if non-view action is selected
                                          if (isNonViewAction && featurePerms.list && !updatedPermissions.includes(featurePerms.list.name)) {
                                            updatedPermissions.push(featurePerms.list.name);
                                          }
                                        } else {
                                          updatedPermissions = updatedPermissions.filter(p => p !== name);
                                        }
                                        setForm({ ...form, permissions: [...new Set(updatedPermissions)] });
                                      };

                                      const isViewDisabled = (featurePerms) => {
                                        if (featurePerms.list?.name === 'dashboard-view') return true;
                                        return !!(
                                          (featurePerms.create && form.permissions && form.permissions.includes(featurePerms.create.name)) ||
                                          (featurePerms.edit && form.permissions && form.permissions.includes(featurePerms.edit.name)) ||
                                          (featurePerms.delete && form.permissions && form.permissions.includes(featurePerms.delete.name)) ||
                                          (featurePerms.export && form.permissions && form.permissions.includes(featurePerms.export.name))
                                        );
                                      };

                                      return (
                                        <tr key={`${menu}-${featureName}`} className={i % 2 === 0 ? 'table-tr-light' : 'table-tr-dark'}>
                                          {index === 0 && (
                                            <td rowSpan={featureKeys.length} className="align-middle fw-bold bg-light">
                                              {menu}
                                            </td>
                                          )}
                                          <td>{featureName}</td>
                                          <td className="text-center">
                                            {featurePerms.create && (
                                              <Form.Check
                                                type="switch"
                                                checked={form.permissions && form.permissions.includes(featurePerms.create.name)}
                                                onChange={(e) => toggleSingle(featurePerms.create.name, e.target.checked, true)}
                                              />
                                            )}
                                          </td>
                                          <td className="text-center">
                                            {featurePerms.edit && (
                                              <Form.Check
                                                type="switch"
                                                checked={form.permissions && form.permissions.includes(featurePerms.edit.name)}
                                                onChange={(e) => toggleSingle(featurePerms.edit.name, e.target.checked, true)}
                                              />
                                            )}
                                          </td>
                                          <td className="text-center">
                                            {featurePerms.list && (
                                              <Form.Check
                                                type="switch"
                                                checked={form.permissions && form.permissions.includes(featurePerms.list.name)}
                                                onChange={(e) => toggleSingle(featurePerms.list.name, e.target.checked, false)}
                                                disabled={isViewDisabled(featurePerms)}
                                              />
                                            )}
                                          </td>
                                          <td className="text-center">
                                            {featurePerms.delete && (
                                              <Form.Check
                                                type="switch"
                                                checked={form.permissions && form.permissions.includes(featurePerms.delete.name)}
                                                onChange={(e) => toggleSingle(featurePerms.delete.name, e.target.checked, true)}
                                              />
                                            )}
                                          </td>
                                          <td className="text-center">
                                            {featurePerms.export && (
                                              <Form.Check
                                                type="switch"
                                                checked={form.permissions && form.permissions.includes(featurePerms.export.name)}
                                                onChange={(e) => toggleSingle(featurePerms.export.name, e.target.checked, true)}
                                              /> 
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    });
                                  })
                                ) : (
                                  <NoDataFound colspan="7" message="No Permissions Found" />
                                )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="demo-inline-spacing d-flex justify-content-end">
                      <Link to={"/roles"}>
                        <button
                          type="button"
                          className="btn btn-primary iclose_btn"
                        >
                          Close
                        </button>
                      </Link>
                      <button
                        disabled={btnDisabled}
                        type="submit"
                        className="btn btn-success isubmit_button"
                        onClick={() => submit()}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleEdit;
